import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3 md:gap-4" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex flex-row items-center h-auto sm:h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium truncate" }, "Data User", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Tambah", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_9 = { class: "intro-y col-span-12" }
const _hoisted_10 = { class: "intro-y col-span-12 box pt-3 px-3 pb-5" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-2 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col md:flex-row items-center col-span-3 md:col-span-1" }, null, -1)
const _hoisted_13 = { class: "w-full col-span-3 md:col-span-2" }
const _hoisted_14 = { class: "w-full md:w-56 relative text-gray-700 dark:text-gray-300 md:ml-auto" }
const _hoisted_15 = ["src", "title"]
const _hoisted_16 = { class: "flex flex-row justify-between" }
const _hoisted_17 = {
  id: "modal-data-user",
  class: "modal p-0"
}
const _hoisted_18 = { class: "modal__content modal__content--lg" }
const _hoisted_19 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_20 = { class: "font-medium text-base mr-auto" }
const _hoisted_21 = { class: "px-3 md:px-5 py-3" }
const _hoisted_22 = { class: "flex flex-col sm:flex-row items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Nama", -1)
const _hoisted_24 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Email", -1)
const _hoisted_26 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Phone", -1)
const _hoisted_28 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "w-full whitespace-nowrap sm:w-20 sm:text-right sm:mr-5" }, "Akses / Role", -1)
const _hoisted_30 = { class: "w-1/2" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "w-full whitespace-nowrap sm:w-20 sm:text-right sm:mr-5" }, "Status", -1)
const _hoisted_34 = { class: "w-1/2" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Username", -1)
const _hoisted_38 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Password", -1)
const _hoisted_40 = { class: "relative w-full sm:w-5/6" }
const _hoisted_41 = { class: "flex flex-col" }
const _hoisted_42 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Pin", -1)
const _hoisted_44 = { class: "relative w-full sm:w-5/6" }
const _hoisted_45 = { class: "absolute top-0 right-0 rounded-r w-14 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600 cursor-pointer" }
const _hoisted_46 = {
  key: 0,
  class: "text-theme-6 my-1 ml-1 sm:ml-24"
}
const _hoisted_47 = { class: "px-5 py-3 text-center border-t border-gray-200 dark:border-dark-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Edit3Icon = _resolveComponent("Edit3Icon")!
  const _component_Trash2Icon = _resolveComponent("Trash2Icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_xIcon = _resolveComponent("xIcon")!
  const _component_TailSelect = _resolveComponent("TailSelect")!
  const _component_ModalDetailUser = _resolveComponent("ModalDetailUser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button bg-theme-1 hover:bg-primary text-white flex items-center w-auto mr-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUser()))
            }, [
              _createVNode(_component_PlusIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_7
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getListUserData())),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_8
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input w-full box pr-10 border border-gray-400 dark:bg-dark-4",
                placeholder: "Search...",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataUser.search) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.dataUser.search]
              ]),
              _createVNode(_component_SearchIcon, {
                onClick: _ctx.handleSearch,
                class: "w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0 cursor-pointer"
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _createVNode(_component_DataTable, {
          headers: _ctx.tabelHeaders,
          items: _ctx.prettierDataUsers,
          loading: _ctx.dataUser.loading,
          "custom-witdh": "120%",
          "loading-div-id": "loadingDUadmin",
          "page-size": _ctx.dataUser.pageSize,
          "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataUser.pageSize) = $event)),
          page: _ctx.dataUser.page,
          "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataUser.page) = $event)),
          "total-data": _ctx.dataUser.totalData,
          "onUpdate:total-data": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataUser.totalData) = $event))
        }, {
          [`item.photo`]: _withCtx(({ item }) => [
            _createElementVNode("img", {
              class: "w-full",
              src: item.photo,
              alt: "photo-user",
              title: 'Photo ' + item.name,
              "data-action": "zoom"
            }, null, 8, _hoisted_15)
          ]),
          [`item.createdAt`]: _withCtx(({ value }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.helper.formatDate(value, "DD MMM, YYYY HH:mm:ss")), 1)
          ]),
          [`item.action`]: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block mr-2",
                content: "Detail",
                onClick: ($event: any) => (_ctx.showDetailUser(item && item.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FileIcon, { class: "w-6 h-6 cursor-pointer text-primary" })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block mr-2",
                content: "Edit",
                onClick: ($event: any) => (_ctx.editUser(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Edit3Icon, { class: "w-6 h-6 cursor-pointer text-theme-12" })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_Tippy, {
                tag: "a",
                href: "javascript:;",
                class: "inline-block",
                content: "Hapus",
                onClick: ($event: any) => (_ctx.deleteUserPopup(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Trash2Icon, { class: "w-6 h-6 cursor-pointer text-theme-6" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["headers", "items", "loading", "page-size", "page", "total-data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.section === "add" ? "Tambah User" : "Edit User"), 1),
          _createElementVNode("a", {
            href: "javascript:;",
            class: "right-0 top-0",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gpf.hideModal('#modal-data-user')))
          }, [
            _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "Nama Lengkap",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exDataUser.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataUser.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "input w-full border flex-1",
              placeholder: "Email Aktif",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.exDataUser.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataUser.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "No. HP",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exDataUser.phone) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataUser.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.exDataUser.roles,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.exDataUser.roles) = $event)),
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeTS($event, 'roles'))),
                options: {
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (r, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: r.value
                    }, _toDisplayString(r.title), 9, _hoisted_31))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.exDataUser.status,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.exDataUser.status) = $event)),
                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeTS($event, 'status'))),
                options: {
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (s, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: s.value
                    }, _toDisplayString(s.title), 9, _hoisted_35))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "Username",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.exDataUser.username) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataUser.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "input pr-12 w-full border col-span-10",
                placeholder: "Password",
                id: "passExDataUser",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.exDataUser.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.exDataUser.password]
              ]),
              _createElementVNode("div", {
                class: "absolute top-0 right-0 rounded-r w-14 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600 cursor-pointer",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showPass('passExDataUser')))
              }, " show ")
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  onkeypress: "if ( isNaN( String.fromCharCode(event.keyCode) ) || event.keyCode == 32) return false;",
                  class: _normalizeClass([
                    'input pr-12 w-full border col-span-10 ',
                    _ctx.required.pin ? 'border-theme-6' : '',
                  ]),
                  placeholder: "Pin",
                  maxlength: "6",
                  id: "pinExDataUser",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.exDataUser.pin) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.exDataUser.pin]
                ]),
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.exDataUser.pin.length) + " / 6 ", 1)
              ])
            ]),
            (_ctx.required.pin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, " This field is required "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("button", {
            type: "button",
            class: "button w-20 bg-theme-6 text-white mr-2",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.gpf.hideModal('#modal-data-user')))
          }, " Close "),
          (_ctx.section === 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "button w-20 bg-theme-1 text-white",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addUserApi()))
              }, " Simpan "))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "button w-20 bg-theme-1 text-white",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.editUserApi()))
              }, " Update "))
        ])
      ])
    ]),
    _createVNode(_component_ModalDetailUser, { "user-id": _ctx.userId }, null, 8, ["user-id"])
  ]))
}